class BankEntryCell extends UITableViewCell
{
    private dayLabel:MUILabel = null;
    private monthLabel:MUILabel = null;
    private conceptLabel:MUILabel = null;
    private referenceLabel:MUILabel = null;
    private metaView:MUIView = null;
    private balanceLabel:MUILabel = null;

    awakeFromHTML(){
        this.dayLabel = MUIOutlet(this, "day-lbl", "MUILabel");
        this.monthLabel = MUIOutlet(this, "month-lbl", "MUILabel");
        this.conceptLabel = MUIOutlet(this, "concept-lbl", "MUILabel");
        this.referenceLabel = MUIOutlet(this, "ref-lbl", "MUILabel");
        this.metaView = MUIOutlet(this, "meta-view", "MUIView");
        this.balanceLabel = MUIOutlet(this, "balance-lbl", "MUILabel");
    }

    set item(item:BankEntry){ this.setItem(item); }
    setItem(item:BankEntry){
        let cf = MUIWebApplication.sharedInstance().delegate.currencyFormatter as MIONumberFormatter;

        this.dayLabel.text = item.date != null ? String(item.date.getDate()) : null;
        this.monthLabel.text = item.date != null ? BankEntryCell.shortMonth(item.date) : null;
        this.conceptLabel.text = item.concept;
        this.referenceLabel.text = BankEntryCell.referenceOf(item);
        this.balanceLabel.text = cf.stringFromNumber(item.balance);

        this.setTags(BankMovementState.tagsOf(item));
    }

    static shortMonth(date:Date) : string {
        return MIODateGetStringForMonth(date.getMonth()).substring(0, 3).toLowerCase();
    }

    // The bank's own reference of the movement
    static referenceOf(item:BankEntry) : string {
        if ((item instanceof BankMovement) == false) return null;
        let mv = item as BankMovement;
        let candidates = [mv.reference, mv.reference1, mv.reference2, mv.documentNumber];
        for (let index = 0; index < candidates.length; index++){
            if (candidates[index] != null && candidates[index].length > 0) return candidates[index];
        }
        return null;
    }

    // The tags after the reference, as #chips
    private tagLabels:MUILabel[] = [];
    private setTags(tags:string[]){
        for (let label of this.tagLabels) label.removeFromSuperview();
        this.tagLabels = [];

        for (let tag of tags) {
            let label = new MUILabel();
            label.init();
            label.layer.style.position = "relative";
            MUICoreLayerAddStyle(label.layer, "label");
            MUICoreLayerAddStyle(label.layer, "mv-tag");
            label.text = "#" + tag;
            this.metaView.addSubview(label);
            this.tagLabels.push(label);
        }
    }
}
